import { useContext } from 'react';
import WebViewContext from '@components/webViewContext';

const useWebViewData = () => useContext(WebViewContext);

export default useWebViewData;
